import { callApi } from 'services/api/api'
import { toastStore } from 'stores/toast'
import { TOAST_TYPE } from 'utils/constants'
import { handleTiles } from 'utils/tiles'
import { baseURL, isLocalEnv } from 'services/api/apiConfig'
import { mockedTiles } from 'mock/tilesMock'

export const getMyFeatures = async (type = 'function') => {
  try {
    const response = await callApi(`${baseURL}/my-features?type=${type}`, 'GET')
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting my features')
    return []
  }
}

export const getTiles = async () => {
  return new Promise(resolve => {
    callApi(`${baseURL}/tiles`)
      .then(response => {
        response = handleTiles(response)
        resolve(response)
      })
      .catch(error => {
        if (isLocalEnv) {
          toastStore.createToast(TOAST_TYPE.ERROR, 'Mocked data', 'We are mocking data for getTiles')
          resolve(handleTiles(mockedTiles))
        } else {
          console.error(error)
          toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'User does not have access. Please contact administrator for options.')
          resolve([])
        }
      })
  })
}
